<template>
  <div>
    <CardsalesForm
      v-show="isFormVisible"
      @submit="login($event)"
      :provider="provider"
      :user_id="user_id"
      :user_password="user_password"
      :isInProgress="isInProgress"
      ref="cardsalesForm"
    />
    <Agreements
      style="margin-bottom: 120px;"
      v-show="isFormVisible"
      :isLoading="isInProgress"
      :isRequiredAllAgreed.sync="isRequiredAllAgreed"
      ref="agreements"
    />
    <CardsalesProgress v-show="isProgressVisible" />
    <div style="margin-top: 60px;">
      <button
        class="button next-button"
        v-ripple
        type="button"
        @click="clickNext"
        :disabled="isInProgress"
      >
        다음
        <v-progress-circular
          style="margin-left: 15px;"
          size="24"
          v-if="isInProgress"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </button>
    </div>
  </div>
</template>
<script>
import PrefetchService from '@/service/auth/PrefetchService'
import CardsalesForm from '@/components/cardsales/Form'
import CardsalesProgress from '@/components/cardsales/Progress'
import cardsalesApi from '@/api/now/cardsalesApi'
import userApi from '@/api/now/userApi'
import termsApi from '@/api/now/termsApi'
import Agreements from './components/agreements/Agreements.vue'

// Variable Section
let dataPrefetch

export default {
  data() {
    return {
      isFormVisible: true,
      isProgressVisible: false,
      credentialId: null,
      provider: 'cfa',
      user_id: null,
      user_password: null,
      isInProgress: false,
      isRequiredAllAgreed: false,
      terms: null
    }
  },
  created() {
    this.$store.commit('ui/headerTitle', '카드매출 불러오기')
    // Variable Section
    this.setDataPrefetch()
  },
  methods: {
    async clickNext() {
      const isValidAccount = await this.$refs.cardsalesForm.$refs.validform.validate()
      if (!isValidAccount) {
        return this.$swal.fire({
          html: '여신협회 계정정보를 입력해 주세요.',
          icon: 'warning',
          confirmButtonText: '확인'
        })
      }

      const isValidAgreements = await this.$refs.agreements.$refs.validform.validate()
      // agreements 컴포넌트에서 동의 목록 가져와 this.terms 에 넣음
      this.terms = this.$refs.agreements.terms
      const termsRequiredAllAgreed = this.terms.every(term => {
        return !term.is_required || term.is_agreed === true
      })

      if (!isValidAgreements || !this.isRequiredAllAgreed || !termsRequiredAllAgreed) {
        return this.$swal.fire({
          html: '필수 항목에 동의해 주세요.',
          icon: 'warning',
          confirmButtonText: '확인'
        })
      }

      // cardsalesForm 컴포넌트에서 submit 성공하면 login() 메소드 호출
      this.$refs.cardsalesForm.submit()
    },
    async setDataPrefetch() {
      // Prefetch
      let queryToken = PrefetchService.filterQuery(this.$route.query)
      if (queryToken) { // (ex) http://localhost:8080/cardsales/form?token=1234
        try {
          const response = await userApi.getPrefetchUser({ token: queryToken.token, 'field': 'cfa' }) // http://127.0.0.1:8000/api/prefetch/user/?token=1&field=cfa
          dataPrefetch = response.data
        } catch (e) {
          console.log(e)
        }
      }
      if (dataPrefetch) {
        this.user_id = dataPrefetch['cfa_id']
        this.user_password = dataPrefetch['cfa_password']
      }
    },
    async login(credential) {
      if (this.isInProgress === true || !this.isRequiredAllAgreed) {
        return
      }
      this.isInProgress = true

      try {
        await this.getCredential()
      } catch (e) {
        console.error(e)
        this.isInProgress = false
        return
      }

      try {
        if (this.credentialId === null) {
          await cardsalesApi.postCredentials(credential)
        } else {
          await cardsalesApi.patchCredentials(this.credentialId, credential)
        }
      } catch (e) {
        console.error(e, 'patchCredentials')
        if (e && e.data) {
          let errmsg = e.data[Object.getOwnPropertyNames(e.data)[0]][0]
          if (errmsg === 'invalid user_id or user_password') {
            alert('잘못된 계정 정보입니다. 아이디와 비밀번호를 다시 확인해주세요.')
          } else {
            alert(errmsg)
          }
        }

        this.isInProgress = false
        return
      }

      // 계정 정보 저장 후 약관 동의 저장
      try {
        await termsApi.agreeTerms(this.terms)

        // 약관 동의 내용 저장 후 카드 매출 평가
        this.insertEvaluation()
      } catch (e) {
        console.error(e, 'termsApi.agreeTerms')
        if (e.status === 409) {
          // 중복 오류인 경우에는 계속 진행되어야 함
          this.insertEvaluation()
        } else {
          this.$swal.fire({
            html: '문제가 발생했습니다. 문제가 지속될 시 고객센터로 문의주세요.',
            icon: 'warning',
            confirmButtonText: '확인'
          })
          this.isInProgress = false
        }
      }
    },
    getCredential() {
      return new Promise(async (resolve, reject) => {
        try {
          let { data } = await cardsalesApi.getCredentials()
          if (data && data.length > 0) {
            data.forEach(credential => {
              if (credential.provider === this.provider) {
                this.credentialId = credential.uuid
                console.log(this.credentialId === null, 'this.credentialId')
              }
            })
          }
          resolve()
        } catch (e) {
          console.error(e, 'getCredentials')
          reject(e)
        }
      })
    },
    async insertEvaluation() {
      console.log('insertEvaluation')
      this.isFormVisible = false
      this.isProgressVisible = true
      try {
        let { data } = await cardsalesApi.postSalesEvaluations()
        this.evaluate(data.uuid)
      } catch (e) {
        console.error(e, 'postSalesEvaluations')
      }
    },
    async evaluate(id) {
      try {
        let { data } = await cardsalesApi.postSalesEvaluate(id)
        if (data.is_qualified === true) {
          if (window.location.host === 'now.funda.kr') { window.fbq('track', 'CompleteRegistration') }
          this.$router.push({ name: 'dashboard' })
        } else {
          this.$router.push({ name: 'cardsales/failure', params: { title: data.title, reason: data.reason } })
        }
      } catch (e) {
        console.error(e, 'postSalesEvaluate')
      }
    }
  },
  components: {
    CardsalesForm,
    CardsalesProgress,
    Agreements
  }
}
</script>
